import React from 'react';
import SectionHeading from '../atoms/SectionHeading';
import ImageComparison from '../molecules/ImageComparison';

const BeforeAfterSection = () => {
    return (
        <section className="py-24 bg-white">
            <div className="container mx-auto px-6">
                <div className="grid lg:grid-cols-2 gap-16 items-center">

                    {/* Text */}
                    <div className="order-2 lg:order-1">
                        <SectionHeading
                            title={<span>Built to Last.<br />Not Just to Look Good.</span>}
                            subtitle="See The Difference"
                            className="text-left mx-0"
                        />

                        <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                            Most salons focus on the "Fresh Set" photo. We focus on the Week 4 reality. Our dry manicure technique creates a seal so tight, hair won't ever get caught in your cuticles.
                        </p>

                        <div className="flex gap-8 mb-8">
                            <div>
                                <p className="text-3xl serif font-bold text-gray-900">28+</p>
                                <p className="text-xs uppercase tracking-widest text-gray-500 mt-1">Days of Wear</p>
                            </div>
                            <div>
                                <p className="text-3xl serif font-bold text-gray-900">100%</p>
                                <p className="text-xs uppercase tracking-widest text-gray-500 mt-1">Sanitary</p>
                            </div>
                        </div>

                        <div className="bg-purple-50 p-6 rounded-xl border-l-4 border-purple-400">
                            <p className="italic text-gray-700 font-medium">"I used to get fills every 2 weeks. With Rich, I go 5 weeks and they still look brand new."</p>
                            <p className="text-xs font-bold mt-4 uppercase tracking-widest text-purple-900">— Sarah J., Verified Client</p>
                        </div>
                    </div>

                    {/* Slider */}
                    <div className="order-1 lg:order-2">
                        <ImageComparison
                            beforeImage="https://images.unsplash.com/photo-1522337660859-02fbefca4702?auto=format&fit=crop&q=80&w=800"
                            afterImage="https://images.unsplash.com/photo-1519014816548-bf5fe059798b?auto=format&fit=crop&q=80&w=800"
                            beforeLabel="Day 1 (Fresh)"
                            afterLabel="Day 28 (Grown Out)"
                        />
                    </div>

                </div>
            </div>
        </section>
    );
};

export default BeforeAfterSection;
